// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"durationFilter_wrapper_IqLRiXV","label":"durationFilter_label_2VCVkqT"};